import {Grid,List,ListItem,IconButton,ListItemText,ListItemAvatar,ListItemSecondaryAction,Typography,Box,Avatar,LinearProgress} from '@mui/material';
import { ReactComponent as ReportChart } from "../../../assets/icons/icon-report-data.svg"
import React, {useEffect,useState} from 'react'
import getDataFromCube from '../../../utils/getCubeData';
import { withStyles } from '@mui/styles';
import { SUBJECT_ICON } from '../../../constants/externalUrls'
import GenericIcon from '../../../assets/icons/Generic_Icon.svg'
import { StringTruncate } from '../../../utils/Reusables';



const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 3,
        borderRadius: 4,
    },
    colorPrimary: {
        backgroundColor: '#dedede',
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#F45E29',
    },
}))(LinearProgress);


function ProgressViewChart({resultSet,fieldsKeyInfo}) {

  const [subjectIconData,setSubjectIconData] = useState([])


  const getSubjectIconData = async () => {
    const members = ["SubjectRackName.rackNameId", "SubjectRackName.subject"]
    try {
      const data = await getDataFromCube(undefined, undefined, undefined, "static_dashboard", members);
      if (data?.length) {
        setSubjectIconData(data)
      }
    }
    catch (error) {
      console.log("Error occured", error)
    }
  }

  useEffect(() => getSubjectIconData(), [])

  const mapSubjectIconData = (subject) => {
    if (subjectIconData.length) {
      const item = subjectIconData.find(ele => ele['SubjectRackName.subject'] === subject)
      if (item) {
        let url = SUBJECT_ICON.replace('{ID}', item['SubjectRackName.rackNameId'])
        return <Avatar src={url} style={{ backgroundColor: '#0000' }}>
          <img src={GenericIcon} alt="subject_icon" />
        </Avatar>
      }
      else {
        return <Avatar src={GenericIcon} />
      }
    }
  }

  const renderProgressViewChart = ({resultSet,fieldsKeyInfo}) => {
      let data1 = resultSet?.loadResponse?.results?.[0]?.data
      const {measureKey,dimensionKey} = fieldsKeyInfo
      if (data1?.length) {
          let keyAreaStats1 = data1.map(ele => {
                     return {
                       subject: ele[dimensionKey[0]],
                       time: Math.round(ele[measureKey[0]], 2)
                    }
                  })  


                                return keyAreaStats1.map((item, i) => (
                                        <ListItem key={i}>
                                            <Box>
                                                <ListItemAvatar>
                                                    {mapSubjectIconData(item?.subject)}
                                                </ListItemAvatar>
                                            </Box>
                                            <Box sx={{ width: '100%' }}>
                                                <Box>
                                                    <ListItemText className="label" primary={item?.subject} />
                                                    <ListItemSecondaryAction>
                                                        <IconButton className='form-icon-btn ' edge="end" aria-label="">
                                                            <Typography className="action-label" >{(item?.time ? item?.time : 0) + '%'}</Typography>
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </Box>
                                                <Box sx={{ width: '100%', mt: 1.5 }}>
                                                    <BorderLinearProgress variant="determinate" value={item?.time > 100 ? 100 : parseInt(item?.time)} />
                                                </Box>
                                            </Box>
                                        </ListItem>
                                    ))
                  }

              return (<Box className="width-100 text-center">
                <Box className='er-report-data-icon'><ReportChart /></Box>
                  <Typography className="er-report-data-info" variant='h4'>{'No Data Found'}</Typography>
                </Box>)
                          

}



  return (
    <List className='er-keyareas-items'>
      {renderProgressViewChart({resultSet,fieldsKeyInfo})}
    </List>
  )
}

export default ProgressViewChart
